import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative pt-12 pb-8 md:pt-32 md:pb-24 overflow-hidden" data-id="element-70">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full bg-cream-100 -z-10" data-id="element-71" />
      <div className="absolute top-[-10%] right-[-5%] w-[50%] h-[60%] rounded-full bg-sage-100/50 blur-3xl -z-10" data-id="element-72" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-73">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-74">
          {/* Text Content */}
          <div className="max-w-2xl" data-id="element-75">
            <FadeIn data-id="element-76">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-charcoal mb-6" data-id="element-77">
                Dile adiós a la hinchazón abdominal y recupera tu energía en
                solo 21 días <br data-id="element-78" />
                <span className="font-light italic text-sage-600 text-3xl md:text-4xl lg:text-5xl" data-id="element-79">
                  (sin dietas de hambre)
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-80">
              <h2 className="text-lg md:text-xl text-charcoal-light mb-10 leading-relaxed font-sans" data-id="element-81">
                El primer protocolo diseñado para mujeres que han probado todo y
                siguen sintiéndose pesadas, inflamadas y cansadas cada mañana.
              </h2>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-82">
              <CTAButton data-id="element-83" />
              
            </FadeIn>
          </div>

          {/* Image */}
          <FadeIn direction="left" delay={0.3} className="relative mx-auto w-full max-w-md lg:max-w-none" data-id="element-84">
            <div className="relative aspect-[4/5] md:aspect-square lg:aspect-[4/5] w-full flex items-center justify-center" data-id="element-85">
              {/* Decorative blob behind image */}
              <div className="absolute inset-0 bg-sage-200 rounded-full blur-3xl opacity-40 transform scale-90" data-id="element-86"></div>
              <img src="https://cdn.magicpatterns.com/uploads/rzZNtrxzqEz2mimBwc3892/PROTOCOLO_ANTI-INFLAMATORIO_21D_Mockup.png" alt="Protocolo Anti-Inflamatorio 21D en Tablet" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl transform -rotate-2 hover:rotate-0 transition-transform duration-700" data-id="element-87" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}